import { render, staticRenderFns } from "./bid-activity.vue?vue&type=template&id=0721b642&"
import script from "./bid-activity.vue?vue&type=script&lang=js&"
export * from "./bid-activity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports